export class FindMessageEntry {

  constructor(public id: number,
              public sentOn: string) {
  }

}
